import { z } from 'zod'
import { TrueFalse } from '~/enums/true-false'
import { listRequestDataSchema } from './list-request-data'

export const getParameterdListRequestSchema = listRequestDataSchema.merge(
  z.object({
    /** 參數類別 */
    pmCode: z.string().optional(),
    /** 參數代碼/名稱 */
    q: z.string().optional(),
    /** 是否啟用 */
    isEnable: z.array(z.nativeEnum(TrueFalse)).optional()
  })
)

export interface GetParameterdListRequest
  extends z.infer<typeof getParameterdListRequestSchema> {}
